<template>
  <section>
    <qx-search-box
      ref="searchBox"
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
import {
  servicerSelectList,
} from 'api/service';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        stateOptions: [], // 状态
        form: [
          { // 单号
            label: '单号',
            value: 'orderId',
            type: 'input',
            default: this.$route.query.orderId,
            placeholder: '请输入单号',
          },
          {
            label: '交易时间',
            value: 'tradeTime',
            type: 'date',
            placeholder: '请输入交易时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 消费人
            label: '消费人',
            value: 'consumerName',
            type: 'input',
            placeholder: '请输入消费人',
          },
          { // 消费人手机
            label: '消费人手机',
            value: 'consumerBill',
            type: 'input',
            placeholder: '请输入消费人手机',
          },
          {
            label: '结算时间',
            value: 'settlTime',
            type: 'date',
            placeholder: '请输入结算时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 状态
            label: '状态',
            value: 'state',
            type: 'select',
            default: -1,
            placeholder: '请选择状态',
          },
        ],
      },
    };
  },
  watch: {
    '$route.query.serviceUserId': function () {
      this.$nextTick(() => {
        if (this.$refs.searchBox) {
          this.$refs.searchBox.setVal('serviceUserId', this.$route.query.serviceUserId);
          this.$refs.searchBox.sub();
        }
      });
    },
    '$route.query.orderId': function () {
      this.$nextTick(() => {
        if (this.$refs.searchBox) {
          this.$refs.searchBox.setVal('orderId', this.$route.query.orderId);
          this.$refs.searchBox.sub();
        }
      });
    },
  },
  activated () {
    this.$nextTick(() => {
      if (this.$refs.searchBox) {
        this.$refs.searchBox.setVal('serviceUserId', this.$route.query.serviceUserId ? Number(this.$route.query.serviceUserId) : '');
        this.$refs.searchBox.setVal('orderId', this.$route.query.orderId);
        this.$refs.searchBox.sub();
      }
    });
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {

      // 交易时间
      if (searchBoxData.tradeTime && searchBoxData.tradeTime.length > 0) {
        searchBoxData.tradeTimeStart = this.formatDate(searchBoxData.tradeTime[0]);
        searchBoxData.tradeTimeEnd = this.formatDate(searchBoxData.tradeTime[1]);
        delete searchBoxData.tradeTime;
      }
      // 结算时间
      if (searchBoxData.settlTime && searchBoxData.settlTime.length > 0) {
        searchBoxData.settlTimeStart = this.formatDate(searchBoxData.settlTime[0]);
        searchBoxData.settlTimeEnd = this.formatDate(searchBoxData.settlTime[1]);
        delete searchBoxData.settlTime;
      }

      const {
        productName,
        productId,
        serviceType,
      } = this.$route.query;
      this.$refs.tableBox.saveSearchBoxData({
        ...searchBoxData,
        productName: encodeURIComponent(productName),
        productId,
        serviceType,
      });
    },
  },
  async created () {
    this.searchBoxData.serviceUserIdOptions = await servicerSelectList();
    const enumsList = await getEnumList({
      codeType: 'SYS_STATE_DESC',
    });
    this.searchBoxData.stateOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
